import { render, staticRenderFns } from "./ProspectiveStatii.vue?vue&type=template&id=0fdfb0af"
import script from "./ProspectiveStatii.vue?vue&type=script&lang=js"
export * from "./ProspectiveStatii.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports